// // src/pages/lauratek-lms.js
// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import imagesLoaded from 'imagesloaded';
// import './OneStepMedi.css';

// /**
//  * API base (edit if needed)
//  */
// const API_URL = 'https://api.securxperts.com:8000';

// ///////////////////////
// // BusinessForm Component
// ///////////////////////
// const BusinessForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     country_code: '',
//     phoneno: '',
//     location: '',
//     industry_type: '',
//     name_of_business: '',
//     poc_name: '',
//     product_taking_time: '',
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name?.trim()) return 'Name is required';
//     if (!form.email?.trim()) return 'Email is required';
//     // simple email check
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.country_code?.trim()) return 'Country code is required';
//     if (!form.phoneno?.trim()) return 'Phone number is required';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const url = `${API_URL}/forms/business`;
//       const payload = { ...form };

//       const resp = await fetch(url, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch (e) {}
//         setStatus({
//           type: 'success',
//           msg: data?.message || 'Business enquiry submitted successfully.',
//         });
//         setForm({
//           name: '',
//           email: '',
//           country_code: '',
//           phoneno: '',
//           location: '',
//           industry_type: '',
//           name_of_business: '',
//           poc_name: '',
//           product_taking_time: '',
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch (e) {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (fetchError) {
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//       console.error('Business submit error:', fetchError);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
//       aria-label="Business Enquiry Form"
//     >
//       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
//         Business Enquiry
//       </h3>

//       <div className="grid grid-cols-1 gap-3">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           type="email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <div className="flex gap-2">
//           <input
//             name="country_code"
//             value={form.country_code}
//             onChange={handleChange}
//             placeholder="+91"
//             required
//             className="w-1/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//           />
//           <input
//             name="phoneno"
//             value={form.phoneno}
//             onChange={handleChange}
//             placeholder="Phone Number"
//             type="tel"
//             required
//             className="w-2/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//           />
//         </div>
//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="City, Country"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="industry_type"
//           value={form.industry_type}
//           onChange={handleChange}
//           placeholder="Industry Type"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="name_of_business"
//           value={form.name_of_business}
//           onChange={handleChange}
//           placeholder="Name of Business"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="poc_name"
//           value={form.poc_name}
//           onChange={handleChange}
//           placeholder="Point of Contact (POC)"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="product_taking_time"
//           value={form.product_taking_time}
//           onChange={handleChange}
//           placeholder="Product Taking Time (e.g. Q3 2025)"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-green-600 hover:bg-green-700 transition px-6 py-3 rounded-full font-semibold w-full mt-4 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Submit Business Enquiry'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-3 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}
//     </form>
//   );
// };

// ///////////////////////
// // InquiryForm Component (student / course contact)
// ///////////////////////
// const InquiryForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     country_code: '',
//     phoneno: '',
//     purpose: '',
//     message: '',
//     course_type: '',
//     product_time: '',
//     location: '',
//     edu_status: '',
//     qualification: '',
//     passedout_year: '',
//     interest: '',
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name?.trim()) return 'Name is required';
//     if (!form.email?.trim()) return 'Email is required';
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.country_code?.trim()) return 'Country code is required';
//     if (!form.phoneno?.trim()) return 'Phone number is required';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const url = `${API_URL}/forms/inquiry`;
//       const payload = { ...form };

//       const resp = await fetch(url, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch (e) {}
//         setStatus({
//           type: 'success',
//           msg: data?.message || 'Inquiry submitted successfully.',
//         });
//         setForm({
//           name: '',
//           email: '',
//           country_code: '',
//           phoneno: '',
//           purpose: '',
//           message: '',
//           course_type: '',
//           product_time: '',
//           location: '',
//           edu_status: '',
//           qualification: '',
//           passedout_year: '',
//           interest: '',
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch (e) {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (fetchError) {
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//       console.error('Inquiry submit error:', fetchError);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
//       aria-label="Course / Education Inquiry Form"
//     >
//       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
//         Course / Student Inquiry
//       </h3>

//       <div className="grid grid-cols-1 gap-3">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           type="email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <div className="flex gap-2">
//           <input
//             name="country_code"
//             value={form.country_code}
//             onChange={handleChange}
//             placeholder="+91"
//             required
//             className="w-1/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//           />
//           <input
//             name="phoneno"
//             value={form.phoneno}
//             onChange={handleChange}
//             placeholder="Phone Number"
//             type="tel"
//             required
//             className="w-2/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//           />
//         </div>

//         <input
//           name="purpose"
//           value={form.purpose}
//           onChange={handleChange}
//           placeholder="Purpose (e.g. Enroll / Info)"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="course_type"
//           value={form.course_type}
//           onChange={handleChange}
//           placeholder="Course Type"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="product_time"
//           value={form.product_time}
//           onChange={handleChange}
//           placeholder="Preferred Start Time"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="City, Country"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="edu_status"
//           value={form.edu_status}
//           onChange={handleChange}
//           placeholder="Education Status (Student / Working)"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="qualification"
//           value={form.qualification}
//           onChange={handleChange}
//           placeholder="Qualification"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="passedout_year"
//           value={form.passedout_year}
//           onChange={handleChange}
//           placeholder="Passed Out Year"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <input
//           name="interest"
//           value={form.interest}
//           onChange={handleChange}
//           placeholder="Area of Interest"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
//         <textarea
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           placeholder="Additional message"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//           rows={4}
//         />
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-indigo-600 hover:bg-indigo-700 transition px-6 py-3 rounded-full font-semibold w-full mt-4 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Submit Inquiry'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-3 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}
//     </form>
//   );
// };

// ///////////////////////
// // Main page: LauraTekLMS
// ///////////////////////
// const LauraTekLMS = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [showScroll, setShowScroll] = useState(false);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   // Ref for hero video
//   const heroVideoRef = useRef(null);

//   useEffect(() => {
//     imagesLoaded(
//       document.querySelectorAll('.content__item-img'),
//       { background: true },
//       () => {
//         document.body.classList.remove('loading');
//         setIsLoading(false);
//       }
//     );
//   }, []);

//   // Parallax for content items
//   useEffect(() => {
//     const items = document.querySelectorAll('.content__item');

//     const handleScroll = () => {
//       items.forEach((item) => {
//         const img = item.querySelector('.content__item-img');
//         const wrapper = img?.parentNode;
//         if (!img || !wrapper) return;

//         const rect = item.getBoundingClientRect();
//         const progress = Math.min(
//           Math.max(
//             (window.innerHeight - rect.top) /
//               (window.innerHeight + rect.height),
//             0
//           ),
//           1
//         );

//         const translateY = progress * 100 - 50;
//         const rotate = progress * -45;

//         img.style.transform = `translateY(${translateY}px)`;
//         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll();
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Show/hide old scroll-to-top button based on scroll position
//   useEffect(() => {
//     const btn = document.querySelector('.scrollToTopBtn');
//     const toggle = () =>
//       btn?.classList.toggle('showBtn', window.scrollY > 600);
//     window.addEventListener('scroll', toggle);
//     return () => window.removeEventListener('scroll', toggle);
//   }, []);

//   // Scroll progress for circular button
//   useEffect(() => {
//     const circumference = 307.919;
//     const handleProgress = () => {
//       const scrollTop =
//         window.scrollY || document.documentElement.scrollTop;
//       const docHeight =
//         document.documentElement.scrollHeight - window.innerHeight;
//       const progress =
//         docHeight > 0
//           ? Math.min(Math.max(scrollTop / docHeight, 0), 1)
//           : 0;
//       setScrollProgress(circumference * progress);
//       setShowScroll(scrollTop > 600);
//     };

//     window.addEventListener('scroll', handleProgress);
//     handleProgress();
//     return () => window.removeEventListener('scroll', handleProgress);
//   }, []);

//   // 🔁 Restart hero video when user scrolls back to top
//   useEffect(() => {
//     let wasNotAtTop = false;

//     const handleVideoReset = () => {
//       const scrollTop =
//         window.scrollY || document.documentElement.scrollTop;
//       const isAtTop = scrollTop < 50;

//       // Only reset when transitioning from not-top → top
//       if (isAtTop && wasNotAtTop && heroVideoRef.current) {
//         heroVideoRef.current.currentTime = 0;
//         heroVideoRef.current.play().catch(() => {});
//       }

//       wasNotAtTop = !isAtTop;
//     };

//     window.addEventListener('scroll', handleVideoReset);
//     handleVideoReset(); // initial

//     return () => window.removeEventListener('scroll', handleVideoReset);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });

//     // also restart video when using the scroll-to-top button
//     if (heroVideoRef.current) {
//       heroVideoRef.current.currentTime = 0;
//       heroVideoRef.current.play().catch(() => {});
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Learning Management System | Simple Online Training LMS</title>
//         <meta
//           name="description"
//           content="Run courses, track learners, and deliver digital training easily with LauraTek LMS. A simple, smart, and scalable solution for online learning."
//         />
//       </Helmet>

//       {/* Loading Screen */}
//       <div
//         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
//           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//       >
//         <h1 className="text-6xl md:text-8xl font-bold text-white animate-pulse">
//           LauraTek LMS
//         </h1>
//       </div>

//       <Navbar />

//       {/* Hero */}
//       <section className="relative h-screen">
//         <video
//           ref={heroVideoRef}
//           className="absolute inset-0 w-full h-full object-cover"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src="/video/LauraTek .mp4" type="video/mp4" />
//         </video>
//       </section>

//       <main className="bg-black text-white">
//         <div className="content content--padded">
//           <section className="py-12 max-w-5xl mx-auto text-left px-6">
//             <h2 className="text-6xl md:text-8xl font-extrabold mb-6 text-center">
//                LauraTek 
//             </h2>
//              <p className="mb-6 text-lg md:text-xl leading-relaxed text-center">Learning Managment System</p>
//             <p className="mb-6 text-lg md:text-xl leading-relaxed">
//               LauraTek is a next-generation,
//               cloud-powered learning platform designed to simplify digital
//               education Powered by SecurXpert Technologies. Built for institutes, companies and training centers,
//               it helps you manage courses, monitor learner activity and deliver
//               both live and recorded sessions effortlessly.
//             </p>

            
//             <div className="space-y-6 text-base md:text-lg">
//               <div>
               
               
//               </div>
//               <div>
               
//               </div>
//             </div>
//           </section>

//           {/* Feature visual cards */}
//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{
//                   backgroundImage: "url('/img/lauratek-courses.jpg')",
//                 }}
//               />
//             </div>
//             <h2 className="content__item-title">Create & Deliver Courses</h2>
//             <p className="content__item-description">
//               Author structured courses, upload materials, and schedule live
//               sessions with a few clicks.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{
//                   backgroundImage: "url('/img/lauratek-analytics.jpg')",
//                 }}
//               />
//             </div>
//             <h2 className="content__item-title">Track Learner Progress</h2>
//             <p className="content__item-description">
//               Dashboards, completion reports, and attendance tracking to measure
//               learner outcomes.
//             </p>
//           </div>

//           {/* CTA */}
//           <section className="text-center py-24">
//             <h2 className="text-4xl md:text-6xl font-bold mb-8">
//               Ready to Train Smarter?
//             </h2>
//             <div className="space-x-6">
//               <Link
//                 to="/get-quoted"
//                 className="inline-block bg-blue-600 text-white px-8 py-3 rounded-full font-bold hover:bg-blue-700 transition"
//               >
//                 Book Free Demo
//               </Link>
//               <Link
//                 to="/contact-us"
//                 className="inline-block bg-white text-blue-600 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition"
//               >
//                 Talk to Team
//               </Link>
//             </div>
//           </section>

//           {/* Contact section with both forms side-by-side */}
//           <section
//             id="contact"
//             className="py-16 bg-gradient-to-b from-black to-gray-900"
//           >
//             <div className="max-w-6xl mx-auto px-6">
//               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
//                 Get in touch
//               </h3>
//               <p className="text-center text-white/70 mb-8">
//                 Have a question or want a demo? Send us a message and our team
//                 will get back to you.
//               </p>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                 <BusinessForm />
//                 <InquiryForm />
//               </div>
//             </div>
//           </section>
//         </div>
//       </main>

//       <Footer />

//       {/* Scroll to Top Button (old button) */}
//       <button
//         onClick={scrollToTop}
//         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
//       >
//         <svg
//           className="w-12 h-12 text-white drop-shadow-2xl"
//           viewBox="0 0 512 512"
//         >
//           <path
//             fill="currentColor"
//             d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z"
//           />
//         </svg>
//       </button>

//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg transition-all"
//         >
//           <svg
//             className="progress-circle -rotate-90 w-12 h-12 absolute"
//             viewBox="-1 -1 102 102"
//           >
//             <path
//               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray="307.919"
//               strokeDashoffset={307.919 - scrollProgress}
//               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-6 h-6 text-white relative z-10"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
//           </svg>
//         </div>
//       )}
//     </>
//   );
// };

// export default LauraTekLMS;






// import React, { useEffect, useRef, useState } from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import imagesLoaded from "imagesloaded";

// // ====================== API BASE ======================
// const API_URL = "https://api.securxperts.com:8000";

// /* ============================================================
//    BUSINESS FORM (FULL LOGIC FROM FIRST CODE – UNCHANGED)
//    ============================================================ */
// const BusinessForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     country_code: "",
//     phoneno: "",
//     location: "",
//     industry_type: "",
//     name_of_business: "",
//     poc_name: "",
//     product_taking_time: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name?.trim()) return "Name is required";
//     if (!form.email?.trim()) return "Email is required";
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return "Enter a valid email";
//     if (!form.country_code?.trim()) return "Country code is required";
//     if (!form.phoneno?.trim()) return "Phone number is required";
//     return null;
//   };

//   const parseFastAPIError = (errorData) => {
//     if (!errorData) return "Unknown error";

//     if (errorData.detail) {
//       if (Array.isArray(errorData.detail)) {
//         return errorData.detail
//           .map((err) => {
//             const field = Array.isArray(err.loc)
//               ? err.loc.slice(1).join(".")
//               : "";
//             const msg = err.msg || err;
//             return field ? `${field}: ${msg}` : msg;
//           })
//           .join(", ");
//       } else if (typeof errorData.detail === "string") {
//         return errorData.detail;
//       }
//     }

//     if (errorData.message) return errorData.message;
//     if (errorData.error) return errorData.error;
//     if (typeof errorData === "string") return errorData;

//     return JSON.stringify(errorData);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: "error", msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const resp = await fetch(`${API_URL}/forms/lauratek-b2b`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });

//       let result;
//       try {
//         const text = await resp.text();
//         result = text ? JSON.parse(text) : null;
//       } catch {
//         result = null;
//       }

//       if (resp.ok) {
//         const success =
//           typeof result === "string" ||
//           result?.success === true ||
//           (result?.message && /success/i.test(result.message)) ||
//           !result?.detail;

//         if (success) {
//           setStatus({
//             type: "success",
//             msg:
//               typeof result === "string"
//                 ? result
//                 : result?.message || "Business enquiry submitted successfully.",
//           });

//           setForm({
//             name: "",
//             email: "",
//             country_code: "",
//             phoneno: "",
//             location: "",
//             industry_type: "",
//             name_of_business: "",
//             poc_name: "",
//             product_taking_time: "",
//           });
//         } else {
//           setStatus({
//             type: "error",
//             msg: parseFastAPIError(result),
//           });
//         }
//       } else {
//         setStatus({
//           type: "error",
//           msg: `Submission failed: ${parseFastAPIError(result)}`,
//         });
//       }
//     } catch (error) {
//       setStatus({
//         type: "error",
//         msg: "Network error. Please try again.",
//       });
//     }

//     setSubmitting(false);
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
//     >
//       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
//         Business Enquiry
//       </h3>

//       <div className="grid grid-cols-1 gap-3">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           className="input"
//         />

//         <input
//           name="email"
//           value={form.email}
//           type="email"
//           onChange={handleChange}
//           placeholder="Email"
//           className="input"
//         />

//         <div className="flex gap-2">
//           <input
//             name="country_code"
//             value={form.country_code}
//             onChange={handleChange}
//             placeholder="+91"
//             className="input w-1/3"
//           />
//           <input
//             name="phoneno"
//             value={form.phoneno}
//             onChange={handleChange}
//             placeholder="Phone Number"
//             className="input w-2/3"
//           />
//         </div>

//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="City, Country"
//           className="input"
//         />

//         <input
//           name="industry_type"
//           value={form.industry_type}
//           onChange={handleChange}
//           placeholder="Industry Type"
//           className="input"
//         />

//         <input
//           name="name_of_business"
//           value={form.name_of_business}
//           onChange={handleChange}
//           placeholder="Name of Business"
//           className="input"
//         />

//         <input
//           name="poc_name"
//           value={form.poc_name}
//           onChange={handleChange}
//           placeholder="Point of Contact (POC)"
//           className="input"
//         />

//         <input
//           name="product_taking_time"
//           value={form.product_taking_time}
//           onChange={handleChange}
//           placeholder="Product Taking Time"
//           className="input"
//         />
//       </div>

//       <button className="submit-btn" disabled={submitting}>
//         {submitting ? "Submitting..." : "Submit Business Enquiry"}
//       </button>

//       {status && (
//         <p
//           className={`text-center mt-3 ${
//             status.type === "success" ? "text-green-400" : "text-red-400"
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}
//     </form>
//   );
// };

// /* ============================================================
//    INQUIRY FORM (FULL VERSION FROM FIRST CODE)
//    ============================================================ */
// const InquiryForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     country_code: "",
//     phoneno: "",
//     purpose: "",
//     message: "",
//     course_type: "",
//     product_time: "",
//     location: "",
//     edu_status: "",
//     qualification: "",
//     passedout_year: "",
//     interest: "",
//   });

//   const [status, setStatus] = useState(null);
//   const [submitting, setSubmitting] = useState(false);

//   const handleChange = (e) =>
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name.trim()) return "Name is required";
//     if (!form.email.trim()) return "Email is required";

//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return "Enter a valid email";

//     if (!form.country_code.trim()) return "Country code is required";
//     if (!form.phoneno.trim()) return "Phone number is required";

//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) return setStatus({ type: "error", msg: err });

//     setSubmitting(true);

//     try {
//       const resp = await fetch(`${API_URL}/forms/lauratek-b2c`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });

//       let result;
//       try {
//         const text = await resp.text();
//         result = text ? JSON.parse(text) : null;
//       } catch {
//         result = null;
//       }

//       if (resp.ok) {
//         setStatus({
//           type: "success",
//           msg: result?.message || "Inquiry submitted successfully.",
//         });

//         setForm({
//           name: "",
//           email: "",
//           country_code: "",
//           phoneno: "",
//           purpose: "",
//           message: "",
//           course_type: "",
//           product_time: "",
//           location: "",
//           edu_status: "",
//           qualification: "",
//           passedout_year: "",
//           interest: "",
//         });
//       } else {
//         setStatus({
//           type: "error",
//           msg: "Submission failed. Try again.",
//         });
//       }
//     } catch {
//       setStatus({
//         type: "error",
//         msg: "Network error. Please try again.",
//       });
//     }

//     setSubmitting(false);
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
//     >
//       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
//         Course / Student Inquiry
//       </h3>

//       <div className="grid grid-cols-1 gap-3">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           className="input"
//         />

//         <input
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           className="input"
//         />

//         <div className="flex gap-2">
//           <input
//             name="country_code"
//             value={form.country_code}
//             onChange={handleChange}
//             placeholder="+91"
//             className="input w-1/3"
//           />
//           <input
//             name="phoneno"
//             value={form.phoneno}
//             onChange={handleChange}
//             placeholder="Phone Number"
//             className="input w-2/3"
//           />
//         </div>

//         <input
//           name="purpose"
//           value={form.purpose}
//           onChange={handleChange}
//           placeholder="Purpose"
//           className="input"
//         />

//         <input
//           name="course_type"
//           value={form.course_type}
//           onChange={handleChange}
//           placeholder="Course Type"
//           className="input"
//         />

//         <input
//           name="product_time"
//           value={form.product_time}
//           onChange={handleChange}
//           placeholder="Preferred Start Time"
//           className="input"
//         />

//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="City, Country"
//           className="input"
//         />

//         <input
//           name="edu_status"
//           value={form.edu_status}
//           onChange={handleChange}
//           placeholder="Education Status"
//           className="input"
//         />

//         <input
//           name="qualification"
//           value={form.qualification}
//           onChange={handleChange}
//           placeholder="Qualification"
//           className="input"
//         />

//         <input
//           name="passedout_year"
//           value={form.passedout_year}
//           onChange={handleChange}
//           placeholder="Passed Out Year"
//           className="input"
//         />

//         <input
//           name="interest"
//           value={form.interest}
//           onChange={handleChange}
//           placeholder="Area of Interest"
//           className="input"
//         />

//         <textarea
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           placeholder="Additional message"
//           className="input"
//           rows={4}
//         />
//       </div>

//       <button className="submit-btn" disabled={submitting}>
//         {submitting ? "Submitting..." : "Submit Inquiry"}
//       </button>

//       {status && (
//         <p
//           className={`text-center mt-3 ${
//             status.type === "success" ? "text-green-400" : "text-red-400"
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}
//     </form>
//   );
// };
// // ====================== MAIN COMPONENT ======================
// export default function LauratekLMS() {
//   return (
//     <div className="w-full overflow-x-hidden font-sans bg-white">
//       <Navbar />

//       {/* ---------------- HERO SECTION ---------------- */}
//       <section className="w-full bg-[#EAF4FF] px-6 md:px-20 py-16 relative overflow-hidden">
//         <div className="absolute top-0 right-0 w-[380px] h-[380px] bg-[#cfe3ff] rounded-full opacity-50 translate-x-24 -translate-y-10"></div>

//         <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">
//           <div>
//             <img src="/img/laurateknew.png" alt="Logo" className="w-32 mb-6" />

//             <h1 className="text-4xl font-bold text-[#063852] mb-4">
//               Empower Learning with <br /> Lauratek LMS
//             </h1>

//             <p className="text-[#063852] opacity-70 mb-6">
//               Experience a top-tier LMS with intuitive workflows and analytics.
//             </p>

//             <div className="flex gap-4">
//               <button className="px-5 py-3 bg-[#063852] text-white rounded-lg shadow">
//                 Get Started
//               </button>

//               <button className="px-5 py-3 bg-white border border-[#063852] text-[#063852] rounded-lg shadow">
//                 Contact Us
//               </button>
//             </div>
//           </div>

//           <div className="flex justify-center">
//             <img
//               src="/img/hero-person.png"
//               alt="hero"
//               className="w-[320px] md:w-[380px] rounded-xl"
//             />
//           </div>
//         </div>
//       </section>

//       {/* ================= VIDEO SECTION ================= */}
//       <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
//         <div className="max-w-7xl mx-auto">
//           <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
//             <video
//               className="w-full"
//               src="/video/lauratek.mp4"
//               muted
//               playsInline
//               autoPlay
//               loop
//               preload="auto"
//               controls={false}
//               key="lauratek-video"
//               onClick={(e) =>
//                 e.currentTarget.paused
//                   ? e.currentTarget.play()
//                   : e.currentTarget.pause()
//               }
//             />
//           </div>
//         </div>
//       </section>

//       {/* ---------------- CONTACT SECTION ---------------- */}
//      <section
//         id="contact"
//         className="py-16 bg-gradient-to-b from-black to-gray-900"
//       >
//         <div className="max-w-6xl mx-auto px-6">
//           <h3 className="text-3xl md:text-4xl font-extrabold text-center text-white mb-6">
//             Get in touch
//           </h3>

//           <p className="text-center text-white/70 mb-8">
//             Have a question or want a demo? Send us a message and our team will
//             get back to you.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             <BusinessForm />
//             <InquiryForm />
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// }



// // // src/pages/lauratek-lms.js
// // import React, { useEffect, useRef, useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { Helmet } from 'react-helmet';
// // import Navbar from '../components/Navbar';
// // import Footer from '../components/Footer';
// // import imagesLoaded from 'imagesloaded';
// // import './OneStepMedi.css';

// // /**
// //  * API base (edit if needed)
// //  */
// // const API_URL = 'https://api.securxperts.com:8000';

// // ///////////////////////
// // // BusinessForm Component
// // ///////////////////////
// // const BusinessForm = () => {
// //   const [form, setForm] = useState({
// //     name: '',
// //     email: '',
// //     country_code: '',
// //     phoneno: '',
// //     location: '',
// //     industry_type: '',
// //     name_of_business: '',
// //     poc_name: '',
// //     product_taking_time: '',
// //   });
// //   const [submitting, setSubmitting] = useState(false);
// //   const [status, setStatus] = useState(null);

// //   const handleChange = (e) =>
// //     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

// //   const validate = () => {
// //     if (!form.name?.trim()) return 'Name is required';
// //     if (!form.email?.trim()) return 'Email is required';
// //     // simple email check
// //     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //     if (!emailRe.test(form.email)) return 'Enter a valid email';
// //     if (!form.country_code?.trim()) return 'Country code is required';
// //     if (!form.phoneno?.trim()) return 'Phone number is required';
// //     return null;
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setStatus(null);

// //     const err = validate();
// //     if (err) {
// //       setStatus({ type: 'error', msg: err });
// //       return;
// //     }

// //     setSubmitting(true);
// //     try {
// //       const url = `${API_URL}/forms/business`;
// //       const payload = { ...form };

// //       const resp = await fetch(url, {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify(payload),
// //       });

// //       if (resp.ok) {
// //         let data = null;
// //         try {
// //           data = await resp.json();
// //         } catch (e) {}
// //         setStatus({
// //           type: 'success',
// //           msg: data?.message || 'Business enquiry submitted successfully.',
// //         });
// //         setForm({
// //           name: '',
// //           email: '',
// //           country_code: '',
// //           phoneno: '',
// //           location: '',
// //           industry_type: '',
// //           name_of_business: '',
// //           poc_name: '',
// //           product_taking_time: '',
// //         });
// //       } else {
// //         let errText = `Server responded with ${resp.status}`;
// //         try {
// //           const json = await resp.json();
// //           if (json?.error) errText = json.error;
// //           else if (json?.message) errText = json.message;
// //         } catch (e) {
// //           const txt = await resp.text().catch(() => null);
// //           if (txt) errText = txt;
// //         }
// //         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
// //       }
// //     } catch (fetchError) {
// //       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
// //       console.error('Business submit error:', fetchError);
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   return (
// //     <form
// //       onSubmit={handleSubmit}
// //       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
// //       aria-label="Business Enquiry Form"
// //     >
// //       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
// //         Business Enquiry
// //       </h3>

// //       <div className="grid grid-cols-1 gap-3">
// //         <input
// //           name="name"
// //           value={form.name}
// //           onChange={handleChange}
// //           placeholder="Full Name"
// //           required
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="email"
// //           value={form.email}
// //           onChange={handleChange}
// //           placeholder="Email"
// //           type="email"
// //           required
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <div className="flex gap-2">
// //           <input
// //             name="country_code"
// //             value={form.country_code}
// //             onChange={handleChange}
// //             placeholder="+91"
// //             required
// //             className="w-1/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //           />
// //           <input
// //             name="phoneno"
// //             value={form.phoneno}
// //             onChange={handleChange}
// //             placeholder="Phone Number"
// //             type="tel"
// //             required
// //             className="w-2/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //           />
// //         </div>
// //         <input
// //           name="location"
// //           value={form.location}
// //           onChange={handleChange}
// //           placeholder="City, Country"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="industry_type"
// //           value={form.industry_type}
// //           onChange={handleChange}
// //           placeholder="Industry Type"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="name_of_business"
// //           value={form.name_of_business}
// //           onChange={handleChange}
// //           placeholder="Name of Business"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="poc_name"
// //           value={form.poc_name}
// //           onChange={handleChange}
// //           placeholder="Point of Contact (POC)"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="product_taking_time"
// //           value={form.product_taking_time}
// //           onChange={handleChange}
// //           placeholder="Product Taking Time (e.g. Q3 2025)"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //       </div>

// //       <button
// //         type="submit"
// //         disabled={submitting}
// //         className="bg-green-600 hover:bg-green-700 transition px-6 py-3 rounded-full font-semibold w-full mt-4 disabled:opacity-50"
// //       >
// //         {submitting ? 'Submitting...' : 'Submit Business Enquiry'}
// //       </button>

// //       {status && (
// //         <p
// //           role="status"
// //           className={`text-center mt-3 text-sm ${
// //             status.type === 'success' ? 'text-green-400' : 'text-red-400'
// //           }`}
// //         >
// //           {status.msg}
// //         </p>
// //       )}
// //     </form>
// //   );
// // };

// // ///////////////////////
// // // InquiryForm Component (student / course contact)
// // ///////////////////////
// // const InquiryForm = () => {
// //   const [form, setForm] = useState({
// //     name: '',
// //     email: '',
// //     country_code: '',
// //     phoneno: '',
// //     purpose: '',
// //     message: '',
// //     course_type: '',
// //     product_time: '',
// //     location: '',
// //     edu_status: '',
// //     qualification: '',
// //     passedout_year: '',
// //     interest: '',
// //   });
// //   const [submitting, setSubmitting] = useState(false);
// //   const [status, setStatus] = useState(null);

// //   const handleChange = (e) =>
// //     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

// //   const validate = () => {
// //     if (!form.name?.trim()) return 'Name is required';
// //     if (!form.email?.trim()) return 'Email is required';
// //     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //     if (!emailRe.test(form.email)) return 'Enter a valid email';
// //     if (!form.country_code?.trim()) return 'Country code is required';
// //     if (!form.phoneno?.trim()) return 'Phone number is required';
// //     return null;
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setStatus(null);

// //     const err = validate();
// //     if (err) {
// //       setStatus({ type: 'error', msg: err });
// //       return;
// //     }

// //     setSubmitting(true);
// //     try {
// //       const url = `${API_URL}/forms/inquiry`;
// //       const payload = { ...form };

// //       const resp = await fetch(url, {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify(payload),
// //       });

// //       if (resp.ok) {
// //         let data = null;
// //         try {
// //           data = await resp.json();
// //         } catch (e) {}
// //         setStatus({
// //           type: 'success',
// //           msg: data?.message || 'Inquiry submitted successfully.',
// //         });
// //         setForm({
// //           name: '',
// //           email: '',
// //           country_code: '',
// //           phoneno: '',
// //           purpose: '',
// //           message: '',
// //           course_type: '',
// //           product_time: '',
// //           location: '',
// //           edu_status: '',
// //           qualification: '',
// //           passedout_year: '',
// //           interest: '',
// //         });
// //       } else {
// //         let errText = `Server responded with ${resp.status}`;
// //         try {
// //           const json = await resp.json();
// //           if (json?.error) errText = json.error;
// //           else if (json?.message) errText = json.message;
// //         } catch (e) {
// //           const txt = await resp.text().catch(() => null);
// //           if (txt) errText = txt;
// //         }
// //         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
// //       }
// //     } catch (fetchError) {
// //       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
// //       console.error('Inquiry submit error:', fetchError);
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   return (
// //     <form
// //       onSubmit={handleSubmit}
// //       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
// //       aria-label="Course / Education Inquiry Form"
// //     >
// //       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
// //         Course / Student Inquiry
// //       </h3>

// //       <div className="grid grid-cols-1 gap-3">
// //         <input
// //           name="name"
// //           value={form.name}
// //           onChange={handleChange}
// //           placeholder="Full Name"
// //           required
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="email"
// //           value={form.email}
// //           onChange={handleChange}
// //           placeholder="Email"
// //           type="email"
// //           required
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <div className="flex gap-2">
// //           <input
// //             name="country_code"
// //             value={form.country_code}
// //             onChange={handleChange}
// //             placeholder="+91"
// //             required
// //             className="w-1/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //           />
// //           <input
// //             name="phoneno"
// //             value={form.phoneno}
// //             onChange={handleChange}
// //             placeholder="Phone Number"
// //             type="tel"
// //             required
// //             className="w-2/3 p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //           />
// //         </div>

// //         <input
// //           name="purpose"
// //           value={form.purpose}
// //           onChange={handleChange}
// //           placeholder="Purpose (e.g. Enroll / Info)"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="course_type"
// //           value={form.course_type}
// //           onChange={handleChange}
// //           placeholder="Course Type"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="product_time"
// //           value={form.product_time}
// //           onChange={handleChange}
// //           placeholder="Preferred Start Time"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="location"
// //           value={form.location}
// //           onChange={handleChange}
// //           placeholder="City, Country"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="edu_status"
// //           value={form.edu_status}
// //           onChange={handleChange}
// //           placeholder="Education Status (Student / Working)"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="qualification"
// //           value={form.qualification}
// //           onChange={handleChange}
// //           placeholder="Qualification"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="passedout_year"
// //           value={form.passedout_year}
// //           onChange={handleChange}
// //           placeholder="Passed Out Year"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <input
// //           name="interest"
// //           value={form.interest}
// //           onChange={handleChange}
// //           placeholder="Area of Interest"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //         />
// //         <textarea
// //           name="message"
// //           value={form.message}
// //           onChange={handleChange}
// //           placeholder="Additional message"
// //           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
// //           rows={4}
// //         />
// //       </div>

// //       <button
// //         type="submit"
// //         disabled={submitting}
// //         className="bg-indigo-600 hover:bg-indigo-700 transition px-6 py-3 rounded-full font-semibold w-full mt-4 disabled:opacity-50"
// //       >
// //         {submitting ? 'Submitting...' : 'Submit Inquiry'}
// //       </button>

// //       {status && (
// //         <p
// //           role="status"
// //           className={`text-center mt-3 text-sm ${
// //             status.type === 'success' ? 'text-green-400' : 'text-red-400'
// //           }`}
// //         >
// //           {status.msg}
// //         </p>
// //       )}
// //     </form>
// //   );
// // };

// // ///////////////////////
// // // Main page: LauraTekLMS
// // ///////////////////////
// // const LauraTekLMS = () => {
// //   const [isLoading, setIsLoading] = useState(true);
// //   const [showScroll, setShowScroll] = useState(false);
// //   const [scrollProgress, setScrollProgress] = useState(0);

// //   // Ref for hero video
// //   const heroVideoRef = useRef(null);

// //   useEffect(() => {
// //     imagesLoaded(
// //       document.querySelectorAll('.content__item-img'),
// //       { background: true },
// //       () => {
// //         document.body.classList.remove('loading');
// //         setIsLoading(false);
// //       }
// //     );
// //   }, []);

// //   // Parallax for content items
// //   useEffect(() => {
// //     const items = document.querySelectorAll('.content__item');

// //     const handleScroll = () => {
// //       items.forEach((item) => {
// //         const img = item.querySelector('.content__item-img');
// //         const wrapper = img?.parentNode;
// //         if (!img || !wrapper) return;

// //         const rect = item.getBoundingClientRect();
// //         const progress = Math.min(
// //           Math.max(
// //             (window.innerHeight - rect.top) /
// //               (window.innerHeight + rect.height),
// //             0
// //           ),
// //           1
// //         );

// //         const translateY = progress * 100 - 50;
// //         const rotate = progress * -45;

// //         img.style.transform = `translateY(${translateY}px)`;
// //         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
// //       });
// //     };

// //     window.addEventListener('scroll', handleScroll);
// //     handleScroll();
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   // Show/hide old scroll-to-top button based on scroll position
// //   useEffect(() => {
// //     const btn = document.querySelector('.scrollToTopBtn');
// //     const toggle = () =>
// //       btn?.classList.toggle('showBtn', window.scrollY > 600);
// //     window.addEventListener('scroll', toggle);
// //     return () => window.removeEventListener('scroll', toggle);
// //   }, []);

// //   // Scroll progress for circular button
// //   useEffect(() => {
// //     const circumference = 307.919;
// //     const handleProgress = () => {
// //       const scrollTop =
// //         window.scrollY || document.documentElement.scrollTop;
// //       const docHeight =
// //         document.documentElement.scrollHeight - window.innerHeight;
// //       const progress =
// //         docHeight > 0
// //           ? Math.min(Math.max(scrollTop / docHeight, 0), 1)
// //           : 0;
// //       setScrollProgress(circumference * progress);
// //       setShowScroll(scrollTop > 600);
// //     };

// //     window.addEventListener('scroll', handleProgress);
// //     handleProgress();
// //     return () => window.removeEventListener('scroll', handleProgress);
// //   }, []);

// //   // 🔁 Restart hero video when user scrolls back to top
// //   useEffect(() => {
// //     let wasNotAtTop = false;

// //     const handleVideoReset = () => {
// //       const scrollTop =
// //         window.scrollY || document.documentElement.scrollTop;
// //       const isAtTop = scrollTop < 50;

// //       // Only reset when transitioning from not-top → top
// //       if (isAtTop && wasNotAtTop && heroVideoRef.current) {
// //         heroVideoRef.current.currentTime = 0;
// //         heroVideoRef.current.play().catch(() => {});
// //       }

// //       wasNotAtTop = !isAtTop;
// //     };

// //     window.addEventListener('scroll', handleVideoReset);
// //     handleVideoReset(); // initial

// //     return () => window.removeEventListener('scroll', handleVideoReset);
// //   }, []);

// //   const scrollToTop = () => {
// //     window.scrollTo({ top: 0, behavior: 'smooth' });

// //     // also restart video when using the scroll-to-top button
// //     if (heroVideoRef.current) {
// //       heroVideoRef.current.currentTime = 0;
// //       heroVideoRef.current.play().catch(() => {});
// //     }
// //   };

// //   return (
// //     <>
// //       <Helmet>
// //         <title>Learning Management System | Simple Online Training LMS</title>
// //         <meta
// //           name="description"
// //           content="Run courses, track learners, and deliver digital training easily with LauraTek LMS. A simple, smart, and scalable solution for online learning."
// //         />
// //       </Helmet>

// //       {/* Loading Screen */}
// //       <div
// //         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
// //           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
// //         }`}
// //       >
// //         <h1 className="text-6xl md:text-8xl font-bold text-white animate-pulse">
// //           LauraTek LMS
// //         </h1>
// //       </div>

// //       <Navbar />

// //       {/* Hero */}
// //       <section className="relative h-screen">
// //         <video
// //           ref={heroVideoRef}
// //           className="absolute inset-0 w-full h-full object-cover"
// //           autoPlay
// //           loop
// //           muted
// //           playsInline
// //         >
// //           <source src="/video/LauraTek .mp4" type="video/mp4" />
// //         </video>
// //       </section>

// //       <main className="bg-black text-white">
// //         <div className="content content--padded">
// //           <section className="py-12 max-w-5xl mx-auto text-left px-6">
// //             <h2 className="text-6xl md:text-8xl font-extrabold mb-6 text-center">
// //                LauraTek 
// //             </h2>
// //              <p className="mb-6 text-lg md:text-xl leading-relaxed text-center">Learning Managment System</p>
// //             <p className="mb-6 text-lg md:text-xl leading-relaxed">
// //               LauraTek is a next-generation,
// //               cloud-powered learning platform designed to simplify digital
// //               education Powered by SecurXpert Technologies. Built for institutes, companies and training centers,
// //               it helps you manage courses, monitor learner activity and deliver
// //               both live and recorded sessions effortlessly.
// //             </p>

            
// //             <div className="space-y-6 text-base md:text-lg">
// //               <div>
               
               
// //               </div>
// //               <div>
               
// //               </div>
// //             </div>
// //           </section>

// //           {/* Feature visual cards */}
// //           <div
// //             className="content__item content__item--expand"
// //             style={{ ['--aspect-ratio']: '7/5' }}
// //           >
// //             <div className="content__item-imgwrap">
// //               <div
// //                 className="content__item-img"
// //                 style={{
// //                   backgroundImage: "url('/img/lauratek-courses.jpg')",
// //                 }}
// //               />
// //             </div>
// //             <h2 className="content__item-title">Create & Deliver Courses</h2>
// //             <p className="content__item-description">
// //               Author structured courses, upload materials, and schedule live
// //               sessions with a few clicks.
// //             </p>
// //           </div>

// //           <div
// //             className="content__item content__item--expand"
// //             style={{ ['--aspect-ratio']: '7/5' }}
// //           >
// //             <div className="content__item-imgwrap">
// //               <div
// //                 className="content__item-img"
// //                 style={{
// //                   backgroundImage: "url('/img/lauratek-analytics.jpg')",
// //                 }}
// //               />
// //             </div>
// //             <h2 className="content__item-title">Track Learner Progress</h2>
// //             <p className="content__item-description">
// //               Dashboards, completion reports, and attendance tracking to measure
// //               learner outcomes.
// //             </p>
// //           </div>

// //           {/* CTA */}
// //           <section className="text-center py-24">
// //             <h2 className="text-4xl md:text-6xl font-bold mb-8">
// //               Ready to Train Smarter?
// //             </h2>
// //             <div className="space-x-6">
// //               <Link
// //                 to="/get-quoted"
// //                 className="inline-block bg-blue-600 text-white px-8 py-3 rounded-full font-bold hover:bg-blue-700 transition"
// //               >
// //                 Book Free Demo
// //               </Link>
// //               <Link
// //                 to="/contact-us"
// //                 className="inline-block bg-white text-blue-600 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition"
// //               >
// //                 Talk to Team
// //               </Link>
// //             </div>
// //           </section>

// //           {/* Contact section with both forms side-by-side */}
// //           <section
// //             id="contact"
// //             className="py-16 bg-gradient-to-b from-black to-gray-900"
// //           >
// //             <div className="max-w-6xl mx-auto px-6">
// //               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
// //                 Get in touch
// //               </h3>
// //               <p className="text-center text-white/70 mb-8">
// //                 Have a question or want a demo? Send us a message and our team
// //                 will get back to you.
// //               </p>

// //               <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
// //                 <BusinessForm />
// //                 <InquiryForm />
// //               </div>
// //             </div>
// //           </section>
// //         </div>
// //       </main>

// //       <Footer />

// //       {/* Scroll to Top Button (old button) */}
// //       <button
// //         onClick={scrollToTop}
// //         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
// //       >
// //         <svg
// //           className="w-12 h-12 text-white drop-shadow-2xl"
// //           viewBox="0 0 512 512"
// //         >
// //           <path
// //             fill="currentColor"
// //             d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z"
// //           />
// //         </svg>
// //       </button>

// //       {showScroll && (
// //         <div
// //           onClick={scrollToTop}
// //           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg transition-all"
// //         >
// //           <svg
// //             className="progress-circle -rotate-90 w-12 h-12 absolute"
// //             viewBox="-1 -1 102 102"
// //           >
// //             <path
// //               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
// //               fill="none"
// //               stroke="white"
// //               strokeWidth="4"
// //               strokeDasharray="307.919"
// //               strokeDashoffset={307.919 - scrollProgress}
// //               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
// //             />
// //           </svg>
// //           <svg
// //             xmlns="http://www.w3.org/2000/svg"
// //             className="w-6 h-6 text-white relative z-10"
// //             fill="none"
// //             viewBox="0 0 24 24"
// //             stroke="currentColor"
// //             strokeWidth={2}
// //           >
// //             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
// //           </svg>
// //         </div>
// //       )}
// //     </>
// //   );
// // };

// // export default LauraTekLMS;







// import React from "react";
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';


// export default function LauratekLMS() {
//   return (
//     <div className="w-full overflow-x-hidden font-sans bg-white">
//         <Navbar />

//       {/* ====================== HERO SECTION ====================== */}
//       <section className="w-full bg-[#EAF4FF] px-6 md:px-20 py-16 relative overflow-hidden">
        
//         {/* Background Shape */}
//         <div className="absolute top-0 right-0 w-[380px] h-[380px] bg-[#cfe3ff] rounded-full opacity-50 translate-x-24 -translate-y-10"></div>

//         <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">

//           {/* Left Content */}
//           <div>
//            <img
//             src="/img/laurateknew.png"
//             alt="Logo"
//             className="w-32 mb-6"
//           />
//             <h1 className="text-4xl font-bold leading-tight text-[#063852] mb-4">
//               Empower Learning with <br /> Lauratek LMS
//             </h1>

//             <p className="text-[#063852] opacity-70 mb-6">
//               Experience a top-tier LMS delivering intuitive workflows,
//               immersive learning, and advanced analytics for modern education.
//             </p>

//             <div className="flex gap-4">
//               <button className="px-5 py-3 bg-[#063852] text-white rounded-lg shadow">
//                 Get Started
//               </button>

//               <button className="px-5 py-3 bg-white border border-[#063852] text-[#063852] rounded-lg shadow">
//                 Contact Us
//               </button>
//             </div>
//           </div>

//           {/* Right Image */}
//           <div className="flex justify-center">
//             <img
//               src="/img/hero-person.png"
//               alt="hero"
//               className="w-[320px] md:w-[380px] rounded-xl"
//             />
//           </div>

//         </div>
//       </section>


//        {/* FULL-WIDTH VIDEO SECTION – LOOP + CLICK PAUSE/PLAY + RESTART ON REFRESH */}
// <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
//   <div className="max-w-7xl mx-auto">

//     <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
//       <video
//         className="w-full block"
//         src="/video/LauraTek .mp4"
//         muted                    // Required for autoplay
//         playsInline
//         autoPlay                 // Starts immediately
//         loop                     // Plays continuously forever
//         preload="auto"
//         controls={false}         // No control bar
//         // Restart from beginning every time page loads/refreshes
//         key="lauratek-video"     
//         // Click = Pause / Play
//         onClick={(e) => {
//           const video = e.currentTarget;
//           video.paused ? video.play() : video.pause();
//         }}
//       >
//         Your browser does not support HTML5 video.
//       </video>

//       {/* ONLY Fullscreen Button – appears on hover */}
//       <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             const video = e.currentTarget.closest('div').querySelector('video');
//             if (video.requestFullscreen) video.requestFullscreen();
//             else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
//             else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
//             else if (video.msRequestFullscreen) video.msRequestFullscreen();
//           }}
//           className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
//           title="Fullscreen"
//         >
//           <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
//               d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5" />
//           </svg>
//         </button>
//       </div>

//       {/* Optional: Subtle pulsing play icon in center */}
//       {/* <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//         <div className="animate-pulse">
//           <div className="w-20 h-20 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
//             <svg className="w-10 h-10 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M8 5v14l11-7z"/>
//             </svg>
//           </div>
//         </div>
//       </div> */}
//     </div>

//   </div>
// </section>

//       {/* ====================== IMMERSIVE LEARNING EXPERIENCE ====================== */}
//       <section className="w-full py-16 px-6 md:px-20">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-10">
//           Immersive Learning Experience
//         </h2>

//         <div className="grid md:grid-cols-4 gap-6">

//           {[
//             {
//               img: "/img/card1.png",
//               title: "Flexible Course Design",
//               text: "Create engaging learning paths, quizzes, and structured modules with ease."
//             },
//             {
//               img: "/img/card2.png",
//               title: "Automated Assessments",
//               text: "Smart evaluation system with instant scoring, analytics & insights."
//             },
//             {
//               img: "/img/card3.png",
//               title: "Resource Management",
//               text: "Upload, organize & manage course materials for seamless learning."
//             },
//             {
//               img: "/img/card4.png",
//               title: "Role-Specific Dashboards",
//               text: "Custom dashboards for learners, trainers, and admins."
//             },
//           ].map((item, i) => (
//             <div key={i} className="bg-white shadow-lg rounded-xl p-6 text-center border">
//               <img src={item.img} alt="card" className="w-12 h-12 mx-auto mb-4" />
//               <h3 className="font-bold text-[#063852] mb-2">{item.title}</h3>
//               <p className="text-sm opacity-70">{item.text}</p>
//             </div>
//           ))}

//         </div>
//       </section>


//       {/* ====================== INTELLIGENT OPERATIONS ====================== */}
//       <section className="w-full py-16 px-6 md:px-20 bg-[#F5FAFF]">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-12">
//           Intelligent Learning Operations <br /> for Maximum Efficiency
//         </h2>

//         <div className="max-w-3xl mx-auto">
//           <ul className="list-disc list-inside text-[#063852] leading-relaxed space-y-3">
//             <li>AI-Powered Operational Flow</li>
//             <li>Interactive & Personalized Paths</li>
//             <li>Role-Based Workflow Automation</li>
//             <li>Targeted Analytics for Learner Efficiency</li>
//             <li>Auto-Generated Reports & Insights</li>
//           </ul>
//         </div>
//       </section>


//       {/* ====================== ADVANCED FUNCTIONALITIES ====================== */}
//       <section className="w-full py-16 px-6 md:px-20">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-12">
//           Explore Advanced Functionalities
//         </h2>

//         <div className="grid md:grid-cols-3 gap-6">

//           {[
//             {
//               img: "/img/feat1.png",
//               title: "Live Proctoring",
//               text: "Monitor exams in real-time with automated fraud detection."
//             },
//             {
//               img: "/img/feat2.png",
//               title: "Advanced Analytics",
//               text: "In-depth learning insights and performance tracking."
//             },
//             {
//               img: "/img/feat3.png",
//               title: "AI-Based Event Tracking",
//               text: "Track learner engagement through AI powered models."
//             },
//             {
//               img: "/img/feat4.png",
//               title: "Automated Scoring",
//               text: "AI-driven scoring for subjective & objective tests."
//             },
//             {
//               img: "/img/feat5.png",
//               title: "Assessment Builder",
//               text: "Easily create robust exams and quizzes with templates."
//             },
//             {
//               img: "/img/feat6.png",
//               title: "Video Analytics",
//               text: "Understand engagement with detailed video analysis."
//             },
//           ].map((feature, i) => (
//             <div key={i} className="bg-white shadow-md border rounded-xl overflow-hidden">
//               <img src={feature.img} alt="feature" className="w-full h-40 object-cover" />
//               <div className="p-5">
//                 <h3 className="font-bold text-[#063852]">{feature.title}</h3>
//                 <p className="text-sm opacity-70 mt-2">{feature.text}</p>
//               </div>
//             </div>
//           ))}

//         </div>
//       </section>
//       <Footer />

//     </div>
//   );
// }




// import React, { useEffect, useRef, useState } from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import imagesLoaded from "imagesloaded";
 
// // ====================== API BASE ======================
// const API_URL = "https://api.securxperts.com:8000";
 
// /* ============================================================
//    BUSINESS FORM (FULL LOGIC FROM FIRST CODE – UNCHANGED)
//    ============================================================ */
// const BusinessForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     country_code: "",
//     phoneno: "",
//     location: "",
//     industry_type: "",
//     name_of_business: "",
//     poc_name: "",
//     product_taking_time: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);
 
//   const handleChange = (e) =>
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
 
//   const validate = () => {
//     if (!form.name?.trim()) return "Name is required";
//     if (!form.email?.trim()) return "Email is required";
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return "Enter a valid email";
//     if (!form.country_code?.trim()) return "Country code is required";
//     if (!form.phoneno?.trim()) return "Phone number is required";
//     return null;
//   };
 
//   const parseFastAPIError = (errorData) => {
//     if (!errorData) return "Unknown error";
 
//     if (errorData.detail) {
//       if (Array.isArray(errorData.detail)) {
//         return errorData.detail
//           .map((err) => {
//             const field = Array.isArray(err.loc)
//               ? err.loc.slice(1).join(".")
//               : "";
//             const msg = err.msg || err;
//             return field ? `${field}: ${msg}` : msg;
//           })
//           .join(", ");
//       } else if (typeof errorData.detail === "string") {
//         return errorData.detail;
//       }
//     }
 
//     if (errorData.message) return errorData.message;
//     if (errorData.error) return errorData.error;
//     if (typeof errorData === "string") return errorData;
 
//     return JSON.stringify(errorData);
//   };
 
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);
 
//     const err = validate();
//     if (err) {
//       setStatus({ type: "error", msg: err });
//       return;
//     }
 
//     setSubmitting(true);
//     try {
//       const resp = await fetch(`${API_URL}/forms/lauratek-b2b`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
 
//       let result;
//       try {
//         const text = await resp.text();
//         result = text ? JSON.parse(text) : null;
//       } catch {
//         result = null;
//       }
 
//       if (resp.ok) {
//         const success =
//           typeof result === "string" ||
//           result?.success === true ||
//           (result?.message && /success/i.test(result.message)) ||
//           !result?.detail;
 
//         if (success) {
//           setStatus({
//             type: "success",
//             msg:
//               typeof result === "string"
//                 ? result
//                 : result?.message || "Business enquiry submitted successfully.",
//           });
 
//           setForm({
//             name: "",
//             email: "",
//             country_code: "",
//             phoneno: "",
//             location: "",
//             industry_type: "",
//             name_of_business: "",
//             poc_name: "",
//             product_taking_time: "",
//           });
//         } else {
//           setStatus({
//             type: "error",
//             msg: parseFastAPIError(result),
//           });
//         }
//       } else {
//         setStatus({
//           type: "error",
//           msg: `Submission failed: ${parseFastAPIError(result)}`,
//         });
//       }
//     } catch (error) {
//       setStatus({
//         type: "error",
//         msg: "Network error. Please try again.",
//       });
//     }
 
//     setSubmitting(false);
//   };
 
//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
//     >
//       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
//         Business Enquiry
//       </h3>
 
//       <div className="grid grid-cols-1 gap-3">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           className="input"
//         />
 
//         <input
//           name="email"
//           value={form.email}
//           type="email"
//           onChange={handleChange}
//           placeholder="Email"
//           className="input"
//         />
 
//         <div className="flex gap-2">
//           <input
//             name="country_code"
//             value={form.country_code}
//             onChange={handleChange}
//             placeholder="+91"
//             className="input w-1/3"
//           />
//           <input
//             name="phoneno"
//             value={form.phoneno}
//             onChange={handleChange}
//             placeholder="Phone Number"
//             className="input w-2/3"
//           />
//         </div>
 
//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="City, Country"
//           className="input"
//         />
 
//         <input
//           name="industry_type"
//           value={form.industry_type}
//           onChange={handleChange}
//           placeholder="Industry Type"
//           className="input"
//         />
 
//         <input
//           name="name_of_business"
//           value={form.name_of_business}
//           onChange={handleChange}
//           placeholder="Name of Business"
//           className="input"
//         />
 
//         <input
//           name="poc_name"
//           value={form.poc_name}
//           onChange={handleChange}
//           placeholder="Point of Contact (POC)"
//           className="input"
//         />
 
//         <input
//           name="product_taking_time"
//           value={form.product_taking_time}
//           onChange={handleChange}
//           placeholder="Product Taking Time"
//           className="input"
//         />
//       </div>
 
//       <button className="submit-btn" disabled={submitting}>
//         {submitting ? "Submitting..." : "Submit Business Enquiry"}
//       </button>
 
//       {status && (
//         <p
//           className={`text-center mt-3 ${
//             status.type === "success" ? "text-green-400" : "text-red-400"
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}
//     </form>
//   );
// };
 
// /* ============================================================
//    INQUIRY FORM (FULL VERSION FROM FIRST CODE)
//    ============================================================ */
// const InquiryForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     country_code: "",
//     phoneno: "",
//     purpose: "",
//     message: "",
//     course_type: "",
//     product_time: "",
//     location: "",
//     edu_status: "",
//     qualification: "",
//     passedout_year: "",
//     interest: "",
//   });
 
//   const [status, setStatus] = useState(null);
//   const [submitting, setSubmitting] = useState(false);
 
//   const handleChange = (e) =>
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
 
//   const validate = () => {
//     if (!form.name.trim()) return "Name is required";
//     if (!form.email.trim()) return "Email is required";
 
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return "Enter a valid email";
 
//     if (!form.country_code.trim()) return "Country code is required";
//     if (!form.phoneno.trim()) return "Phone number is required";
 
//     return null;
//   };
 
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);
 
//     const err = validate();
//     if (err) return setStatus({ type: "error", msg: err });
 
//     setSubmitting(true);
 
//     try {
//       const resp = await fetch(`${API_URL}/forms/lauratek-b2c`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
 
//       let result;
//       try {
//         const text = await resp.text();
//         result = text ? JSON.parse(text) : null;
//       } catch {
//         result = null;
//       }
 
//       if (resp.ok) {
//         setStatus({
//           type: "success",
//           msg: result?.message || "Inquiry submitted successfully.",
//         });
 
//         setForm({
//           name: "",
//           email: "",
//           country_code: "",
//           phoneno: "",
//           purpose: "",
//           message: "",
//           course_type: "",
//           product_time: "",
//           location: "",
//           edu_status: "",
//           qualification: "",
//           passedout_year: "",
//           interest: "",
//         });
//       } else {
//         setStatus({
//           type: "error",
//           msg: "Submission failed. Try again.",
//         });
//       }
//     } catch {
//       setStatus({
//         type: "error",
//         msg: "Network error. Please try again.",
//       });
//     }
 
//     setSubmitting(false);
//   };
 
//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-lg mx-auto bg-white/5 p-6 md:p-8 rounded-2xl shadow-lg"
//     >
//       <h3 className="text-xl md:text-2xl font-bold text-center mb-4 text-white">
//         Course / Student Inquiry
//       </h3>
 
//       <div className="grid grid-cols-1 gap-3">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           className="input"
//         />
 
//         <input
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           className="input"
//         />
 
//         <div className="flex gap-2">
//           <input
//             name="country_code"
//             value={form.country_code}
//             onChange={handleChange}
//             placeholder="+91"
//             className="input w-1/3"
//           />
//           <input
//             name="phoneno"
//             value={form.phoneno}
//             onChange={handleChange}
//             placeholder="Phone Number"
//             className="input w-2/3"
//           />
//         </div>
 
//         <input
//           name="purpose"
//           value={form.purpose}
//           onChange={handleChange}
//           placeholder="Purpose"
//           className="input"
//         />
 
//         <input
//           name="course_type"
//           value={form.course_type}
//           onChange={handleChange}
//           placeholder="Course Type"
//           className="input"
//         />
 
//         <input
//           name="product_time"
//           value={form.product_time}
//           onChange={handleChange}
//           placeholder="Preferred Start Time"
//           className="input"
//         />
 
//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="City, Country"
//           className="input"
//         />
 
//         <input
//           name="edu_status"
//           value={form.edu_status}
//           onChange={handleChange}
//           placeholder="Education Status"
//           className="input"
//         />
 
//         <input
//           name="qualification"
//           value={form.qualification}
//           onChange={handleChange}
//           placeholder="Qualification"
//           className="input"
//         />
 
//         <input
//           name="passedout_year"
//           value={form.passedout_year}
//           onChange={handleChange}
//           placeholder="Passed Out Year"
//           className="input"
//         />
 
//         <input
//           name="interest"
//           value={form.interest}
//           onChange={handleChange}
//           placeholder="Area of Interest"
//           className="input"
//         />
 
//         <textarea
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           placeholder="Additional message"
//           className="input"
//           rows={4}
//         />
//       </div>
 
//       <button className="submit-btn" disabled={submitting}>
//         {submitting ? "Submitting..." : "Submit Inquiry"}
//       </button>
 
//       {status && (
//         <p
//           className={`text-center mt-3 ${
//             status.type === "success" ? "text-green-400" : "text-red-400"
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}
//     </form>
//   );
// };
// // ====================== MAIN COMPONENT ======================
// export default function LauratekLMS() {
//   return (
//     <div className="w-full overflow-x-hidden font-sans bg-white">
//       <Navbar />
 
//        {/* ====================== HERO SECTION ====================== */}
//       <section className="w-full bg-[#EAF4FF] px-6 md:px-20 py-16 relative overflow-hidden">
        
//         {/* Background Shape */}
//         <div className="absolute top-0 right-0 w-[380px] h-[380px] bg-[#cfe3ff] rounded-full opacity-50 translate-x-24 -translate-y-10"></div>

//         <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">

//           {/* Left Content */}
//           <div>
//            <img
//             src="/img/laurateknew.png"
//             alt="Logo"
//             className="w-32 mb-6"
//           />
//             <h1 className="text-4xl font-bold leading-tight text-[#063852] mb-4">
//               Empower Learning with <br /> Lauratek LMS
//             </h1>

//             <p className="text-[#063852] opacity-70 mb-6">
//               Experience a top-tier LMS delivering intuitive workflows,
//               immersive learning, and advanced analytics for modern education.
//             </p>

//             <div className="flex gap-4">
//               <button className="px-5 py-3 bg-[#063852] text-white rounded-lg shadow">
//                 Get Started
//               </button>

//               <button className="px-5 py-3 bg-white border border-[#063852] text-[#063852] rounded-lg shadow">
//                 Contact Us
//               </button>
//             </div>
//           </div>

//           {/* Right Image */}
//           <div className="flex justify-center">
//             <img
//               src="/img/hero-person.png"
//               alt="hero"
//               className="w-[320px] md:w-[380px] rounded-xl"
//             />
//           </div>

//         </div>
//       </section>


//      {/* FULL-WIDTH VIDEO SECTION – LOOP + CLICK PAUSE/PLAY + RESTART ON REFRESH */}
// <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
//   <div className="max-w-7xl mx-auto">

//     <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
//       <video
//         className="w-full block"
//         src="/video/LauraTek 2.o.mp4"
//         muted                    // Required for autoplay
//         playsInline
//         autoPlay                 // Starts immediately
//         loop                     // Plays continuously forever
//         preload="auto"
//         controls={false}         // No control bar
//         // Restart from beginning every time page loads/refreshes
//         key="lauratek-video"     
//         // Click = Pause / Play
//         onClick={(e) => {
//           const video = e.currentTarget;
//           video.paused ? video.play() : video.pause();
//         }}
//       >
//         Your browser does not support HTML5 video.
//       </video>

//       {/* ONLY Fullscreen Button – appears on hover */}
//       <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             const video = e.currentTarget.closest('div').querySelector('video');
//             if (video.requestFullscreen) video.requestFullscreen();
//             else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
//             else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
//             else if (video.msRequestFullscreen) video.msRequestFullscreen();
//           }}
//           className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
//           title="Fullscreen"
//         >
//           <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
//               d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5" />
//           </svg>
//         </button>
//       </div>

//       {/* Optional: Subtle pulsing play icon in center */}
//       {/* <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//         <div className="animate-pulse">
//           <div className="w-20 h-20 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
//             <svg className="w-10 h-10 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M8 5v14l11-7z"/>
//             </svg>
//           </div>
//         </div>
//       </div> */}
//     </div>

//   </div>
// </section>

//       {/* ====================== IMMERSIVE LEARNING EXPERIENCE ====================== */}
//       <section className="w-full py-16 px-6 md:px-20">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-10">
//           Immersive Learning Experience
//         </h2>

//         <div className="grid md:grid-cols-4 gap-6">

//           {[
//             {
//               img: "/img/card1.png",
//               title: "Flexible Course Design",
//               text: "Create engaging learning paths, quizzes, and structured modules with ease."
//             },
//             {
//               img: "/img/card2.png",
//               title: "Automated Assessments",
//               text: "Smart evaluation system with instant scoring, analytics & insights."
//             },
//             {
//               img: "/img/card3.png",
//               title: "Resource Management",
//               text: "Upload, organize & manage course materials for seamless learning."
//             },
//             {
//               img: "/img/card4.png",
//               title: "Role-Specific Dashboards",
//               text: "Custom dashboards for learners, trainers, and admins."
//             },
//           ].map((item, i) => (
//             <div key={i} className="bg-white shadow-lg rounded-xl p-6 text-center border">
//               <img src={item.img} alt="card" className="w-12 h-12 mx-auto mb-4" />
//               <h3 className="font-bold text-[#063852] mb-2">{item.title}</h3>
//               <p className="text-sm opacity-70">{item.text}</p>
//             </div>
//           ))}

//         </div>
//       </section>


//       {/* ====================== INTELLIGENT OPERATIONS ====================== */}
//       <section className="w-full py-16 px-6 md:px-20 bg-[#F5FAFF]">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-12">
//           Intelligent Learning Operations <br /> for Maximum Efficiency
//         </h2>

//         <div className="max-w-3xl mx-auto">
//           <ul className="list-disc list-inside text-[#063852] leading-relaxed space-y-3">
//             <li>AI-Powered Operational Flow</li>
//             <li>Interactive & Personalized Paths</li>
//             <li>Role-Based Workflow Automation</li>
//             <li>Targeted Analytics for Learner Efficiency</li>
//             <li>Auto-Generated Reports & Insights</li>
//           </ul>
//         </div>
//       </section>


//       {/* ====================== ADVANCED FUNCTIONALITIES ====================== */}
//       <section className="w-full py-16 px-6 md:px-20">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-12">
//           Explore Advanced Functionalities
//         </h2>

//         <div className="grid md:grid-cols-3 gap-6">

//           {[
//             {
//               img: "/img/feat1.png",
//               title: "Live Proctoring",
//               text: "Monitor exams in real-time with automated fraud detection."
//             },
//             {
//               img: "/img/feat2.png",
//               title: "Advanced Analytics",
//               text: "In-depth learning insights and performance tracking."
//             },
//             {
//               img: "/img/feat3.png",
//               title: "AI-Based Event Tracking",
//               text: "Track learner engagement through AI powered models."
//             },
//             {
//               img: "/img/feat4.png",
//               title: "Automated Scoring",
//               text: "AI-driven scoring for subjective & objective tests."
//             },
//             {
//               img: "/img/feat5.png",
//               title: "Assessment Builder",
//               text: "Easily create robust exams and quizzes with templates."
//             },
//             {
//               img: "/img/feat6.png",
//               title: "Video Analytics",
//               text: "Understand engagement with detailed video analysis."
//             },
//           ].map((feature, i) => (
//             <div key={i} className="bg-white shadow-md border rounded-xl overflow-hidden">
//               <img src={feature.img} alt="feature" className="w-full h-40 object-cover" />
//               <div className="p-5">
//                 <h3 className="font-bold text-[#063852]">{feature.title}</h3>
//                 <p className="text-sm opacity-70 mt-2">{feature.text}</p>
//               </div>
//             </div>
//           ))}

//         </div>
//       </section>
//       {/* ---------------- CONTACT SECTION ---------------- */}
//      <section
//         id="contact"
//         className="py-16 bg-gradient-to-b from-black to-gray-900"
//       >
//         <div className="max-w-6xl mx-auto px-6">
//           <h3 className="text-3xl md:text-4xl font-extrabold text-center text-white mb-6">
//             Get in touch
//           </h3>
 
//           <p className="text-center text-white/70 mb-8">
//             Have a question or want a demo? Send us a message and our team will
//             get back to you.
//           </p>
 
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             <BusinessForm />
//             <InquiryForm />
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// }
 
 

import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import imagesLoaded from "imagesloaded";
 
// ====================== API BASE ======================
const API_URL = "https://api.securxperts.com:8000";
 
/* ============================================================
   POPUP MODAL (UNCHANGED)
   ============================================================ */
const PopupModal = ({ show, onClose, type, message }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="relative bg-white rounded-xl shadow-xl p-6 w-full max-w-md mx-4">
        {/* ❌ CLOSE (manual close still available) */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-lg"
        >
          ✕
        </button>

        <h3
          className={`text-xl font-semibold text-center ${
            type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {type === "success" ? "Success" : "Error"}
        </h3>

        <p className="mt-3 text-center text-gray-700">
          {message}
        </p>
      </div>
    </div>
  );
};

const nameRegex = /^[A-Za-z\s]{3,}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[0-9]{6,15}$/;

/* ============================================================
   BUSINESS FORM
   ============================================================ */
const BusinessForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    country_code: "",
    phoneno: "",
    location: "",
    industry_type: "",
    name_of_business: "",
    poc_name: "",
    product_taking_time: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "", message: "" });

  const openModal = (type, message) => {
    setModalData({ type, message });
    setShowModal(true);
    // window.scrollTo({ top: 0, behavior: "smooth" });

    setTimeout(() => {
      setShowModal(false);
    }, 5000);
  };

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
 
  const validate = () => {
    if (!form.name.trim()) return "Name is required";
    if (!nameRegex.test(form.name))
      return "Name should contain only alphabets (min 3 characters)";

    if (!form.email.trim()) return "Email is required";
    if (!emailRegex.test(form.email)) return "Enter a valid email";

    if (!form.country_code.trim()) return "Country code is required";
    if (!form.phoneno.trim()) return "Phone number is required";
    if (!phoneRegex.test(form.phoneno))
      return "Enter a valid phone number";

    return null;
  };

  const parseFastAPIError = (errorData) => {
    if (!errorData) return "Unknown error";
    if (errorData.detail) {
      if (Array.isArray(errorData.detail)) {
        return errorData.detail.map((err) => err.msg || "").join(", ");
      } else if (typeof errorData.detail === "string") {
        return errorData.detail;
      }
    }
    return errorData.message || errorData.error || "Submission failed";
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();

    const err = validate();
    if (err) return openModal("error", err);

    setSubmitting(true);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        country_code: form.country_code,
        phoneno: form.phoneno,
        location: form.location,
        industry_type: form.industry_type,
        name_of_business: form.name_of_business,
        poc_name: form.poc_name,
        product_taking_time: form.product_taking_time,
      };

      const resp = await fetch(`${API_URL}/forms/lauratek-b2b`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await resp.json();

      if (resp.ok) {
        openModal("success", "Business enquiry submitted successfully!");
        setForm({
          name: "",
          email: "",
          country_code: "",
          phoneno: "",
          location: "",
          industry_type: "",
          name_of_business: "",
          poc_name: "",
          product_taking_time: "",
        });
      } else {
        openModal("error", parseFastAPIError(result));
      }
    } catch {
      openModal("error", "Network error. Please try again.");
    }

    setSubmitting(false);
  };
 
  return (
    <>
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
        <h3 className="text-2xl font-bold text-white text-center mb-6">
          Business Enquiry
        </h3>
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* All input fields remain exactly the same */}
          <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" />
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email Address *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" />
          <div className="flex gap-3">
            <div className="w-[140px] relative">
              <select name="country_code" value={form.country_code} onChange={handleChange} required className="w-full appearance-none px-4 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white focus:outline-none focus:border-white/60 transition">
                <option value="" className="text-black">Code</option>
                <option value="+91" className="text-black">🇮🇳 +91</option>
                <option value="+1" className="text-black">🇺🇸 +1</option>
                <option value="+44" className="text-black">🇬🇧 +44</option>
                <option value="+61" className="text-black">🇦🇺 +61</option>
                <option value="+971" className="text-black">🇦🇪 +971</option>
              </select>
              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-white/70">▼</span>
            </div>
            <input name="phoneno" value={form.phoneno} onChange={handleChange} placeholder="Phone Number *" required className="flex-1 px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          </div>
          <input name="location" value={form.location} onChange={handleChange} placeholder="City, Country" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          <input name="industry_type" value={form.industry_type} onChange={handleChange} placeholder="Industry Type" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          <input name="name_of_business" value={form.name_of_business} onChange={handleChange} placeholder="Business Name" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          <input name="poc_name" value={form.poc_name} onChange={handleChange} placeholder="Point of Contact" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          <input name="product_taking_time" value={form.product_taking_time} onChange={handleChange} placeholder="When do you plan to start?" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
 
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-gradient-to-r from-[#063852] to-[#0a5c7a] hover:from-[#052d40] hover:to-[#084d66] text-white font-bold py-4 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-70"
          >
            {submitting ? "Submitting..." : "Submit Business Enquiry"}
          </button>
        </form>
      </div>

      <PopupModal show={showModal} onClose={() => setShowModal(false)} type={modalData.type} message={modalData.message} />
    </>
  );
};

/* ============================================================
   INQUIRY FORM
   ============================================================ */
const InquiryForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    country_code: "",
    phoneno: "",
    purpose: "",
    message: "",
    course_type: "",
    product_time: "",
    location: "",
    edu_status: "",
    qualification: "",
    passedout_year: "",
    interest: "",
  });
 
  const [submitting, setSubmitting] = useState(false);
 
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "", message: "" });

  const openModal = (type, message) => {
    setModalData({ type, message });
    setShowModal(true);
    // window.scrollTo({ top: 0, behavior: "smooth" });

    setTimeout(() => {
      setShowModal(false);
    }, 5000);
  };

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
 
  const validate = () => {
    if (!form.name.trim()) return "Name is required";
    if (!nameRegex.test(form.name))
      return "Name should contain only alphabets (min 3 characters)";

    if (!form.email.trim()) return "Email is required";
    if (!emailRegex.test(form.email)) return "Enter a valid email";

    if (!form.country_code.trim()) return "Country code is required";
    if (!form.phoneno.trim()) return "Phone number is required";
    if (!phoneRegex.test(form.phoneno))
      return "Enter a valid phone number";

    return null;
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();

    const err = validate();
    if (err) return openModal("error", err);

    setSubmitting(true);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        country_code: form.country_code,
        phoneno: form.phoneno,
        purpose: form.purpose,
        message: form.message,
        course_type: form.course_type,
        product_time: form.product_time,
        location: form.location,
        edu_status: form.edu_status,
        qualification: form.qualification,
        passedout_year: form.passedout_year,
        interest: form.interest,
      };

      const resp = await fetch(`${API_URL}/forms/lauratek-b2c`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await resp.json();

      if (resp.ok) {
        openModal("success", "Inquiry submitted successfully!");
        setForm({
          name: "",
          email: "",
          country_code: "",
          phoneno: "",
          purpose: "",
          message: "",
          course_type: "",
          product_time: "",
          location: "",
          edu_status: "",
          qualification: "",
          passedout_year: "",
          interest: "",
        });
      } else {
        openModal("error", result.detail || "Submission failed");
      }
    } catch {
      openModal("error", "Network error. Please try again.");
    }

    setSubmitting(false);
  };
 
  return (
    <>
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
        <h3 className="text-2xl font-bold text-white text-center mb-6">
          Student / Course Inquiry
        </h3>
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* All input fields remain exactly the same */}
          <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" />
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email Address *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          <div className="flex gap-3">
            <div className="w-[140px] relative">
              <select name="country_code" value={form.country_code} onChange={handleChange} required className="w-full appearance-none px-4 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white focus:outline-none focus:border-white/60 transition">
                <option value="" className="text-black">Code</option>
                <option value="+91" className="text-black">🇮🇳 +91</option>
                <option value="+1" className="text-black">🇺🇸 +1</option>
                <option value="+44" className="text-black">🇬🇧 +44</option>
                <option value="+61" className="text-black">🇦🇺 +61</option>
                <option value="+971" className="text-black">🇦🇪 +971</option>
              </select>
              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-white/70">▼</span>
            </div>
            <input name="phoneno" value={form.phoneno} onChange={handleChange} placeholder="Phone Number *" required className="flex-1 px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          </div>
          <input name="course_type" value={form.course_type} onChange={handleChange} placeholder="Interested Course" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          <input name="location" value={form.location} onChange={handleChange} placeholder="City, Country" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
          <textarea name="message" value={form.message} onChange={handleChange} rows={4} placeholder="Your Message" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 resize-none" />
 
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-gradient-to-r from-[#063852] to-[#0a5c7a] hover:from-[#052d40] hover:to-[#084d66] text-white font-bold py-4 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-70"
          >
            {submitting ? "Submitting..." : "Submit Inquiry"}
          </button>
        </form>
      </div>

      <PopupModal show={showModal} onClose={() => setShowModal(false)} type={modalData.type} message={modalData.message} />
    </>
  );
};
 
// ====================== MAIN COMPONENT ======================
export default function LauratekLMS() {
  return (
    <div className="w-full overflow-x-hidden font-sans bg-white">
     <div className="fixed top-0 left-0 w-full z-[9999]">
  <Navbar />
</div>

 
      {/* HERO SECTION – UPDATED CONTENT */}
      <section className="w-full bg-[#EAF4FF] px-6 md:px-20 py-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[380px] h-[380px] bg-[#cfe3ff] rounded-full opacity-50 translate-x-24 -translate-y-10"></div>
 
        <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">
          <div>
            <img src="/img/110.png" alt="Logo" className="w-32 mb-6" />
            <h1 className="text-4xl font-bold leading-tight text-[#063852] mb-8">
              Advanced Digital Learning Platform
            </h1>
            <p className="text-[#063852] opacity-70 mb-12">
              Lauratek provides a modern online learning platform with intuitive
              course creation, live or on-demand sessions, and real-time learner
              insights.
            </p>
         
          </div>
          <div className="flex justify-center mb-[-92px]">
            <img
              src="/img/india Laura image 1.png"
              alt="hero"
              className="w-[320px] md:w-[380px] rounded-xl"
            />
          </div>
        </div>
      </section>
 
      {/* FULL-WIDTH VIDEO SECTION – UPDATED CONTENT TEXT, SAME STRUCTURE */}
      <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto mb-10 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-[#063852]">
              See Lauratek in Action
            </h2>
            <p className="text-[#063852] opacity-80 mt-3">
              Explore our digital learning platform in a live demo &amp;
              experience easy course creation, automated assessments, real-time
              insights and smart reporting.
            </p>
          </div>
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
            <video
              className="w-full block"
              src="/video/lauratekupdated.mp4"
              muted
              playsInline
              autoPlay
              loop
              preload="auto"
              controls={false}
              key="lauratek-video"
              onClick={(e) => {
                const v = e.currentTarget;
                v.paused ? v.play() : v.pause();
              }}
            >
              Your browser does not support HTML5 video.
            </video>
            <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const v =
                    e.currentTarget.closest("div").querySelector("video");
                  v.requestFullscreen?.() || v.webkitRequestFullscreen?.();
                }}
                className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
                title="Fullscreen"
              >
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>
 
      {/* INNOVATIVE LEARNING ENVIRONMENT – UPDATED CONTENT */}
      <section className="w-full py-16 px-6 md:px-20">
        <h2 className="text-2xl font-bold text-[#063852] text-center mb-10">
          Innovative Learning Environment
        </h2>
        <div className="grid md:grid-cols-4 gap-6">
          {[
            {
              img: "/img/indlaura2.png",
              title: "Modular Course Creation",
              text: "Upload lessons, videos, slides, and materials. Organise them into flexible modules.",
            },
            {
              img: "/img/indlaura3.png",
              title: "Automated Knowledge Checks",
              text: "Create quizzes, assignments, and auto-graded assessments with instant feedback.",
            },
            {
              img: "/img/indlaura4.png",
              title: "All-in-One Content Hub",
              text: "Keep all PDFs, notes, multimedia, and references in a single accessible hub.",
            },
            {
              img: "/img/indlaura5.png",
              title: "Role-Based Access Panels",
              text: "Custom dashboards for admins, trainers, and learners with relevant insights.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white shadow-lg rounded-xl p-6 text-center border"
            >
              <img
                src={item.img}
                alt="card"
                className="w-12 h-12 mx-auto mb-4"
              />
              <h3 className="font-bold text-[#063852] mb-2">{item.title}</h3>
              <p className="text-sm opacity-70">{item.text}</p>
            </div>
          ))}
        </div>
      </section>
 
      {/* SMART LEARNING MANAGEMENT – UPDATED CONTENT */}
      <section className="w-full py-16 px-6 md:px-20 bg-[#F5FAFF]">
        <h2 className="text-2xl font-bold text-[#063852] text-center mb-12">
          Smart Learning Management for Optimal Efficiency
        </h2>
        <div className="max-w-3xl mx-auto">
          <ul className="list-disc list-inside text-[#063852] leading-relaxed space-y-3">
            <li>
              <span className="font-semibold">
                Seamless Workflow Automation:
              </span>{" "}
              Automate routine tasks and reduce manual administration, supported
              by simple dashboards for learning operations efficiently and
              uninterrupted.
            </li>
            <li>
              <span className="font-semibold">Learner Progress Tracking:</span>{" "}
              Track each learner’s journey from enrolment to completion, with
              detailed metrics and analytics to guide instructional strategies
              effectively.
            </li>
            <li>
              <span className="font-semibold">Advanced Reporting Tools:</span>{" "}
              Generate instant reports, certificates and exportable analytics,
              enhancing oversight and operational control across academic and
              professional learning programs.
            </li>
            <li>
              <span className="font-semibold">Secure Compliance Management:</span>{" "}
              Store all data securely with audit-ready records and structured
              reporting, ensuring consistent adherence to regulatory and
              institutional standards.
            </li>
          </ul>
        </div>
      </section>
 
      {/* KEY FEATURES OF DIGITAL LEARNING PLATFORM – UPDATED CONTENT */}
      <section className="w-full py-16 px-6 md:px-20">
        <h2 className="text-2xl font-bold text-[#063852] text-center mb-4">
          Key Features of Digital Learning Platform
        </h2>
        <p className="text-center text-[#063852] opacity-80 max-w-3xl mx-auto mb-10">
          Lauratek India equips educators and organisations with tools to plan,
          deliver, and manage courses efficiently. Features like automated
          assessments, instant certification, real-time dashboards, and a
          centralised resource repository maximise engagement and productivity.
        </p>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            {
              img: "/img/indlaura6.jpg",
              title: "Modular Course Builder",
              text: "Create courses using flexible modules for live or pre-recorded sessions. Support varied teaching methods while organising content efficiently for easy learner access.",
            },
            {
              img: "/img/indlaura7 (2).png",
              title: "Smart Assessments",
              text: "Design self-grading quizzes, assignments, and interactive tests. Provide instant feedback to learners while significantly reducing manual effort for instructors.",
            },
            {
              img: "/img/indlaura8.jpg",
              title: "Automated Certification",
              text: "Automatically generate completion certificates for learners. Customise certificates with institutional branding to ensure professional and standardised recognition.",
            },
            {
              img: "/img/indlaura9.jpg",
              title: "Real-Time Analytics",
              text: "Monitor learner attendance, engagement, and progress through interactive dashboards. Quickly identify learning gaps and adapt strategies to optimise outcomes.",
            },
            {
              img: "/img/indlaura10 copy (2).png",
              title: "Centralised Resource Hub",
              text: "Store all educational content—notes, slides, PDFs, and multimedia—in one accessible hub. Ensure students and staff can retrieve materials instantly without searching.",
            },
            {
              img: "/img/indlaura10.png",
              title: "Role-Specific Reports",
              text: "Provide administrators, instructors, and learners with custom dashboards. Generate detailed performance, attendance, and activity reports in a single click for clear oversight.",
            },
          ].map((f, i) => (
            <div
              key={i}
              className="bg-white shadow-md border rounded-xl overflow-hidden"
            >
              <img
                src={f.img}
                alt={f.title}
               className="w-full h-40 mt-2 object-contain bg-white"

              />
              <div className="p-5">
                <h3 className="font-bold text-[#063852]">{f.title}</h3>
                <p className="text-sm opacity-70 mt-2">{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
 
      {/* NEW PROFESSIONAL CONTACT SECTION – UNCHANGED STRUCTURE */}
     <section
  id="contact"
  className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-[#063852] via-[#084d66] to-[#052d40] text-white"
>
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4">
      Get in Touch
    </h2>

    <p className="text-base sm:text-lg text-white/80 max-w-2xl mx-auto mb-10 md:mb-12">
      Whether you're a business or a student, we're here to help you get
      started with Lauratek LMS.
    </p>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 max-w-5xl mx-auto">
      <BusinessForm />
      <InquiryForm />
    </div>
  </div>
</section>

 
      <Footer />
    </div>
  );
}
 
 